import React from 'react';
import { match } from 'ts-pattern';
import ChatMessagePartText from './parts/chat-message-part-text';
import ChatMessagePartToolInvocation from './parts/chat-message-part-tool';
import type { UIMessagePart } from './types';

export interface ChatMessagePartProps {
  messageId: string;
  part: UIMessagePart;
}

function ChatMessagePart({ messageId, part }: ChatMessagePartProps) {
  return match(part)
    .with({ type: 'text' }, (part) => (
      <ChatMessagePartText messageId={messageId} part={part} />
    ))
    .with({ type: 'tool-invocation' }, (part) => (
      <ChatMessagePartToolInvocation messageId={messageId} part={part} />
    ))
    .otherwise(() => null);
}

export default React.memo(ChatMessagePart);
